import { doQuery } from 'src/api/graphqlClient';
import { ObjT } from 'src/utils/types';

export const getSelfTestEditVersion = (selfTestSlug: string) => {
  return doQuery(
    `query getSelfTest(
      $selfTestSlug: String
    ) {
        selfTest(
          slug: $selfTestSlug
        ) {
          buttonText
          description
          id
          slug
          frontendTitle
          disclaimer
          disclaimerTitle
          image
          authorSet {
            id
            text
            name
          }
          questionSet {
            id
            isDefault
            isSkippable
            created
            hint
            hintTitle
            sortPos
            text
            answerSet {
              id
              score
              sortPos
              text
              explanationSet {
                category
                id
                title
                text
                links {
                  title
                  url
                  siteName
                }
              }
            }
            triggersets {
              id
              triggers {
                id
              }
            }
          }
          scoreRangeSet {
            id
            name
            description
            upperScore
            emergencyPhoneNr
            emergencyUrl
          }
          referenceSet {
            id
            text
            url
          }
        }
    }`,
    {
      selfTestSlug,
    }
  )
    .then((response: ObjT) => {
      return response.selfTest;
    })
    .catch((error: any) => {
      return error.response.selfTest;
    });
};
